import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({ palette, breakpoints }) => ({
    layout: {
      height: "calc(100vh - 72px)",
      boxSizing: "border-box",
    },
    main: {
      height: "calc(100vh - 72px - 72px - 24px)",
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    buttons: {
      width: "100%",
      height: 72,
      display: "flex",
      justifyContent: "flex-end",
      position: "fixed",
      padding: "16px 48px 0 0",
      bottom: 0,
      right: 0,
      borderTop: `1px solid ${palette.grey[300]}`,
      background: "white",
      gap: 16,
    },
    tableContainer: {
       height: "calc(85%)",
      },
      ctaContainer: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 16,
        [breakpoints.down("sm")]: {
          margin: 5,
          marginTop: 5,
        },
      },
      
  }));